import React, { useState } from 'react'
import CloseIcon from '../Icon/icons/Close/index'
import Button, { TYPES } from '../Button/index'

/**
 * @param {Object} props - The props
 * @param {String} props.title - The content title
 * @param {JSX.Element} props.moreContent - The 'show more' info content
 * @param {String} props.moreButtonLabel - The more button label
 * @param {String} props.mobilePopupTitle - The mobile popup title
 * @returns {JSX.Element} DetailPageV3Title
 */

const DetailPageV3Title = (props) => {
  const {
    title,
    moreContent,
    moreButtonLabel,
    mobilePopupTitle,
  } = props

  const showMore = !!moreContent && !!moreButtonLabel
  const [metaOverlayVisible, setMetaOverlayVisible] = useState(false)

  return (
    <div className="detail-page-v3__title">
      <h1 className="detail-page-v3__title-text">
        {title}
        {showMore && (
          <Button
            className="detail-page-v3__more-info-button detail-page-v3__more-info-button--mobile"
            type={TYPES.LINK}
            onClick={() => setMetaOverlayVisible(true)}
          >
              {moreButtonLabel}
          </Button>
        )}
      </h1>
      {showMore && metaOverlayVisible
        && <div className="detail-page-v3__mobile-popup">
          <Button
            type={TYPES.LINK}
            onClick={() => setMetaOverlayVisible(false)}
            className="detail-page-v3__mobile-popup-close-button"
          >
            <CloseIcon color="#151515" />
          </Button>
          <div className="detail-page-v3__mobile-popup-title">
            {mobilePopupTitle}
          </div>
          <div className="detail-page-v3__mobile-popup-content">
            {moreContent}
          </div>
        </div>
      }
    </div>
  )
}

export default DetailPageV3Title
